import React from "react";
import { css } from "@emotion/css";
import type { SessionPhase } from "../../types/state";

const headerStyle = css`
  padding: 12px 16px;
  background: var(--color-bg-subtle);
  border-bottom: 1px solid var(--color-border-subtle);
  display: flex;
  align-items: center;
  gap: 8px;
`;

const phaseKindStyle = css`
  font-size: 0.8em;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--color-text-muted);
  font-weight: 600;
`;

const phaseTitleStyle = css`
  font-size: 0.95em;
  font-weight: 500;
  color: var(--color-text);
`;

const statusBadgeStyle = css`
  font-size: 0.75em;
  padding: 2px 8px;
  border-radius: 12px;
  font-weight: 500;
`;

function getStatusColor(status: string): string {
  switch (status) {
    case "active":
      return "background: var(--color-success-bg); color: var(--color-success-text);";
    case "completed":
      return "background: var(--color-primary-muted); color: var(--color-primary);";
    case "locked":
      return "background: var(--color-bg-raised); color: var(--color-text-muted);";
    default:
      return "background: var(--color-bg-raised); color: var(--color-text-muted);";
  }
}

interface PhaseHeaderProps {
  phase: SessionPhase;
}

export const PhaseHeader: React.FC<PhaseHeaderProps> = ({ phase }) => {
  return (
    <div className={headerStyle} data-testid="phase-header">
      <span className={phaseKindStyle}>{phase.kind}</span>
      {phase.title && <span className={phaseTitleStyle}>{phase.title}</span>}
      <span
        className={css`
          ${statusBadgeStyle}
          ${getStatusColor(phase.status)}
        `}
      >
        {phase.status}
      </span>
    </div>
  );
};
